import { Grid } from '@mui/material';
import { MotiveDataProps } from './props';
import { useMotiveData } from './hook';
import FieldText from '../../../../../components/general/fields/fieldText';
import { formatParams } from '../../../../../../shared/utils/params';
import MultipleAutocompleteField from '../../../../../components/general/fields/multipleAutocompleteField';
import { Checkbox } from '../../../../../components/general/fields/checkbox';

export const MotiveData = (props: MotiveDataProps) => {
    const { formik, typePQR } = useMotiveData(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12} sm={6}>
                <FieldText
                    label="Nombre"
                    name="name"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.name}
                    errors={formik.errors.name}
                    value={formik.values.name}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <MultipleAutocompleteField
                    data={formatParams(typePQR)}
                    label="Tipo PQR"
                    name="parent"
                    size="small"
                    required
                    touched={formik.touched.parent}
                    errors={formik.errors.parent}
                    value={formik.values.parent}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('parent', value)
                    }
                />
            </Grid>
            <Grid item xs={12}>
                <FieldText
                    label="Descripción"
                    name="extra"
                    size="small"
                    rows={3}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.extra}
                    errors={formik.errors.extra}
                    value={formik.values.extra}
                    onChange={formik.handleChange}
                    required={!!props?.data?.id}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <Checkbox
                    label="Activo"
                    checked={Boolean(formik.values.active)}
                    onChange={() => {
                        formik.setFieldValue('active', !formik.values.active);
                    }}
                />
            </Grid>
        </Grid>
    );
};
